import { render, staticRenderFns } from "./AccountsReceivable.vue?vue&type=template&id=4ceef196&scoped=true"
import script from "./AccountsReceivable.vue?vue&type=script&lang=js"
export * from "./AccountsReceivable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ceef196",
  null
  
)

export default component.exports